<template>
  <div class="appstore clear">
    <div class="download-guide" v-if="download"><img src="/public/download_guide.png" /></div>
    <div class="btn-download-group" v-if="desktop">
      <a :href="this.$config.iOSAPPUrl"><img src="/public/App store-min.png"/></a>
      <a :href="this.$config.androidAPPUrl"><img src="/public/Google Play-min.png"/></a>
    </div>
    <div class="btn-download-group" v-else>
      <a v-on:click="handleEvent" v-if="ios" :href="this.$config.iOSAPPUrl"><img src="/public/App store-min.png"/></a>
      <a v-on:click="handleEvent" v-if="android" :href="this.$config.androidAPPUrl"><img src="/public/Google Play-min.png"/></a>
    </div>
  </div>
</template>
<script>
export default {
  props:["pageName"],
  mounted: function() {
  },
  methods: {
    copy: function() {
      this.download = true
    },
    handleEvent: function(event) {
      var elem = document.getElementById('btn_copy')
      if(elem) {
        elem.click()
      }
      if(this.pageName === "profile"){
        this.$ga.event('download', 'profile_download_the_app', 'profile_download_the_app')
      } else if(this.pageName === "question"){
        this.$ga.event('download', 'question_download_the_app', 'question_download_the_app')
      } else if(this.pageName === "pollGame"){
        this.$ga.event('download', 'pollgame_download_the_app', 'pollgame_download_the_app')
      } else if(this.pageName === "privacyPolicy"){
        this.$ga.event('download', 'pp_download_the_app', 'pp_download_the_app')
      } else if(this.pageName === "tos"){
        this.$ga.event('download', 'tos_download_the_app', 'tos_download_the_app')
      } else if(this.pageName === "home"){
        this.$ga.event('download', 'home_download_the_app', 'home_download_the_app')
      }
    },
  },
  data () {
    return {
      'download': false,
      'ios': (this.$store.state.device == 'ios'),
      'android': (this.$store.state.device == 'android'),
      'desktop': (this.$store.state.device == 'desktop') ? true : false,

    }
  },
  components: {
  }
};
</script>
<style lang="stylus">
.appstore
  position relative
  text-align center
  display: flex;
  justify-content: center;
  margin-top: 30px !important;

  .download-guide
    text-align center
    position: absolute;
    top: 10px;
    width: 100%;
    img
      height 16px;
  .btn-download-group
    margin 36px auto 0
    padding: 0 0 10px 0
    display: flex;
    justify-content: space-between;
    width: 450px;
    img
      width 214px


.mobile .appstore a
  margin 0 auto
  display block
  font-size: 18px;
  line-height: 56px;
  text-align: center;
  font-weight bold
  height: 56px;
  width: 240px;
  border-radius: unset !important;
  box-shadow: unset !important;

  background-color: unset !important;
  color:  unset !important;

</style>



// WEBPACK FOOTER //
// Appstore.vue